import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-table-loader',
  templateUrl: './table-loader.component.html',
  styleUrl: './table-loader.component.scss',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
})
/**
 * @deprecated
 */
export class TableLoaderComponent {
  @Input({ required: true }) isLoading: boolean;
  @Input({ required: true }) isNoData: boolean;
}
